import React, { Component } from 'react'
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from 'react-router-dom'
import LogInSelector from './components/LogInSelector'
import LogInEmailForm from './components/LogInEmailForm'
import LogInEmailPasswordForm from './components/LogInEmailPasswordForm'
import firebase from './firebaseBundle'
import VerifyEmailPending from './components/VerifyEmailPending'
import GlobalStyles from './components/styled-components/GlobalStyles'
import initializeFirebase from './initializeFirebase'
import emailExistsInFirebase from './emailExistsInFirebase'
import emailExistsInCognito from './emailExistsInCognito'
import logInFirebaseUser from './logInFirebaseUser'
import logInCognitoUser from './logInCognitoUser'
import createFirebaseAccount from './createFirebaseAccount'
import VerifyEmailFailure from './components/VerifyEmailFailure'
import sendVerificationEmail from './sendVerificationEmail'
import getRedirectURIFromQueryParams from './getRedirectURIFromQueryParams'
import getClientIDFromQueryParams from './getClientIDFromQueryParams'
import getActionCodeFromQueryParams from './getActionCodeFromQueryParams'
import getOAuthStateFromQueryParams from './getOAuthStateFromQueryParams'
import { ThemeProvider } from 'styled-components'
import { defaultTheme } from './components/styled-components/defaultTheme'
import getFirebaseJWTForCurrentUser from './getFirebaseJWTForCurrentUser'
import authenticateAnovaIdentity from './authenticateAnovaIdentity'
import PasswordResetEmailForm from './components/PasswordResetEmailForm'
import PasswordResetEmailSent from './components/PasswordResetEmailSent'
import MakeNewPasswordForm from './components/MakeNewPasswordForm'
import PasswordChanged from './components/PasswordChanged'
import PasswordResetFailure from './components/PasswordResetFailure'
import resetFirebasePassword from './resetFirebasePassword'
import checkFirebasePasswordResetCodeAndGetEmail from './checkFirebasePasswordResetCodeAndGetEmail'
import userCreatedAccountViaFacebook from './userCreatedAccountViaFacebook'
import createAnovaIdentityWithVerifiedEmailFromCognito from './createAnovaIdentityWithVerifiedEmailFromCognito'
import createAnovaIdentityWithVerifiedEmailFromFacebook from './createAnovaIdentityWithVerifiedEmailFromFacebook'
import redirectToURL from './redirectToURL'
import addOutgoingParamsToRedirectURL from './addOutgoingParamsToRedirectURL'
import LoadingIndicator from './components/LoadingIndicator'
import getPendingCredentialFromSessionStorage from './getPendingCredentialFromSessionStorage'
import storePendingCredentialInSessionStorage from './storePendingCredentialInSessionStorage'
import ContinueWithGoogle from './components/ContinueWithGoogle'
import ContinueWithFacebook from './components/ContinueWithFacebook'
import ContinueWithApple from './components/ContinueWithApple'
import alreadyLoggedInWithFacebook from './alreadyLoggedInWithFacebook'
import alreadyLoggedInWithGoogle from './alreadyLoggedInWithGoogle'
import alreadyLoggedInWithApple from './alreadyLoggedInWithApple'
import VerifyEmailSuccess from './components/VerifyEmailSuccess'
import isNewGoogleUser from './isNewGoogleUser'
import jwtDecode from 'jwt-decode'
import storeRedirectURIInLocalStorage from './storeRedirectURIInLocalStorage'
import getRedirectURIFromLocalStorage from './getRedirectURIFromLocalStorage'
import storeEmailInLocalStorage from './storeEmailInLocalStorage'
import storeOAuthStateInLocalStorage from './storeOAuthStateInLocalStorage'
import storeClientIDInLocalStorage from './storeClientIDInLocalStorage'
import storeIsExistingCognitoUserInLocalStorage from './storeIsExistingCognitoUserInLocalStorage'
import storeIsExistingFirebaseUserInLocalStorage from './storeIsExistingFirebaseUserInLocalStorage'
import storeShouldShowEnterPasswordToLinkFacebookToastFromLocalStorage from './storeShouldShowEnterPasswordToLinkFacebookToastFromLocalStorage'
import storeNativeLogInInLocalStorage from './storeNativeLogInInLocalStorage'
import getOAuthStateFromLocalStorage from './getOAuthStateFromLocalStorage'
import getClientIDFromLocalStorage from './getClientIDFromLocalStorage'
import getResponseTypeFromLocalStorage from './getResponseTypeFromLocalStorage'
import getIsExistingCognitoUserFromLocalStorage from './getIsExistingCognitoUserFromLocalStorage'
import getIsExistingFirebaseUserFromLocalStorage from './getIsExistingFirebaseUserFromLocalStorage'
import getShouldShowEnterPasswordToLinkFacebookToastFromLocalStorage from './getShouldShowEnterPasswordToLinkFacebookToastFromLocalStorage'
import getNativeLogInFromQueryParams from './getNativeLogInFromQueryParams'
import getNativeLogInFromLocalStorage from './getNativeLogInFromLocalStorage'
import removeShouldShowEnterPasswordToLinkFacebookToastFromLocalStorage from './removeShouldShowEnterPasswordToLinkFacebookToastFromLocalStorage'
import removePendingCredentialFromSessionStorage from './removePendingCredentialFromSessionStorage'
import removeNativeLogInFromLocalStorage from './removeNativeLogInFromLocalStorage'
import { analyticsTrack } from './analytics'
import { marketingEmailOptInUser } from './subscribeEmailToFoodNerdList'

// Initialize FontAwesome
import { library as fontAwesomeLibrary } from '@fortawesome/fontawesome-svg-core'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import getNativeFacebookTokenFromQueryParams from './getNativeFacebookTokenFromQueryParams'
import storeNativeFacebookTokenInSessionStorage from './storeNativeFacebookTokenInSessionStorage'
import getNativeFacebookTokenFromSessionStorage from './getNativeFacebookTokenFromSessionStorage'
import getNativePendingCredentialProviderFromQueryParams from './getNativePendingCredentialProviderFromQueryParams'
import storeNativePendingCredentialProviderInLocalStorage from './storeNativePendingCredentialProviderInLocalStorage'
import getNativePendingCredentialProviderFromLocalStorage from './getNativePendingCredentialProviderFromLocalStorage'
import addUserCancelledErrorToRedirectURL from './addUserCancelledErrorToRedirectURL'
import getResponseTypeFromQueryParams from './getResponseTypeFromQueryParams'
fontAwesomeLibrary.add(faCheck)

class App extends Component {
  state = {
    email: '',
    password: '',
    wrongPassword: false,
    weakPassword: false,
    emailAlreadyInUse: false,
    invalidEmail: false,
    userNotFound: false,
    expiredActionCode: false,
    invalidActionCode: false,
    shouldRedirect: false,
    redirectURI: '',
    redirectToEmailVerification: false,
    redirectToEnterPassword: false,
    redirectToPasswordChanged: false,
    redirectToContinueWithGoogle: false,
    redirectToContinueWithFacebook: false,
    redirectToContinueWithApple: false,
    isExistingFirebaseUser: false,
    isExistingCognitoUser: false,
    showGDPROptions: true,
    isLoadingOrRedirecting: true,
    pendingCredential: null,
    shouldShowEnterPasswordToLinkFacebookToast: false,
    oAuthStateParameter: '',
    clientID: '',
    nativeLogIn: '',
    marketingEmailOptInUser: false,
  }

  async componentWillMount() {
    await initializeFirebase()

    let responseType = getResponseTypeFromQueryParams()
    if (responseType) {
      storeRedirectURIInLocalStorage(responseType)
    } else {
      responseType = getResponseTypeFromLocalStorage() || ''
    }

    let redirectURI = getRedirectURIFromQueryParams()
    if (redirectURI) {
      storeRedirectURIInLocalStorage(redirectURI)
    } else {
      redirectURI = getRedirectURIFromLocalStorage() || ''
    }

    let oAuthStateParameter = getOAuthStateFromQueryParams()
    if (oAuthStateParameter) {
      storeOAuthStateInLocalStorage(oAuthStateParameter)
    } else {
      oAuthStateParameter = getOAuthStateFromLocalStorage() || ''
    }

    let clientID = getClientIDFromQueryParams()
    if (clientID) {
      storeClientIDInLocalStorage(clientID)
    } else {
      clientID = getClientIDFromLocalStorage() || ''
    }

    let nativeLogIn = getNativeLogInFromQueryParams()
    if (nativeLogIn) {
      storeNativeLogInInLocalStorage(nativeLogIn)
    } else {
      nativeLogIn = getNativeLogInFromLocalStorage() || ''
    }

    let nativePendingCredentialProvider = getNativePendingCredentialProviderFromQueryParams()
    if (nativePendingCredentialProvider) {
      storeNativePendingCredentialProviderInLocalStorage(
        nativePendingCredentialProvider
      )
    } else {
      nativePendingCredentialProvider =
        getNativePendingCredentialProviderFromLocalStorage() || ''
    }

    let nativeFacebookToken = getNativeFacebookTokenFromQueryParams()
    if (nativeFacebookToken) {
      storeNativeFacebookTokenInSessionStorage(nativeFacebookToken)
    } else {
      nativeFacebookToken = getNativeFacebookTokenFromSessionStorage() || ''
    }

    firebase.auth().onAuthStateChanged(async loggedInUser => {
      try {
        let redirectToEmailVerification = false
        let isLoadingOrRedirecting = false
        let email = this.state.email
        let redirectToEnterPassword = false
        let redirectToContinueWithGoogle = false
        let isExistingCognitoUser =
          getIsExistingCognitoUserFromLocalStorage() || false
        let isExistingFirebaseUser =
          getIsExistingFirebaseUserFromLocalStorage() || false
        let shouldShowEnterPasswordToLinkFacebookToast =
          getShouldShowEnterPasswordToLinkFacebookToastFromLocalStorage() ||
          false

        let pendingCredential =
          this.state.pendingCredential ||
          getPendingCredentialFromSessionStorage()

        // TODO
        /// ////////////////////////////////////////////////////////////////////////
        // DELETE THIS BLOCK OF CODE ONCE WE RETIRE THE iOS APP
        // This is a hacky fix for our hybrid Native / Web login experience with Facebook.
        /// ////////////////////////////////////////////////////////////////////////
        if (nativeFacebookToken && nativePendingCredentialProvider) {
          pendingCredential = firebase.auth.FacebookAuthProvider.credential(
            nativeFacebookToken
          )

          if (nativePendingCredentialProvider === 'password') {
            shouldShowEnterPasswordToLinkFacebookToast = true
            storeShouldShowEnterPasswordToLinkFacebookToastFromLocalStorage(
              true
            )
            redirectToEnterPassword = true
            isExistingFirebaseUser = true
            storeIsExistingFirebaseUserInLocalStorage(true)
            storePendingCredentialInSessionStorage(pendingCredential)
          } else if (nativePendingCredentialProvider === 'google.com') {
            storePendingCredentialInSessionStorage(pendingCredential)

            redirectToContinueWithGoogle = true
          }
        }
        /// //////////////////////////////////////////////////////////////////////////
        // DELETE THE ABOVE BLOCK OF CODE ONCE WE RETIRE THE iOS APP
        /// //////////////////////////////////////////////////////////////////////////

        if (loggedInUser) {
          if (!isExistingCognitoUser && !isExistingFirebaseUser) {
            marketingEmailOptInUser(email)
          }
          if (loggedInUser.emailVerified) {
            isLoadingOrRedirecting = true

            if (pendingCredential) {
              await loggedInUser.linkAndRetrieveDataWithCredential(
                pendingCredential
              )
              removePendingCredentialFromSessionStorage()
            }
            const firebaseJWT = await getFirebaseJWTForCurrentUser()
            const anovaJWT = await authenticateAnovaIdentity(firebaseJWT)
            const anovaJWTClaims = jwtDecode(anovaJWT)

            if (isNewGoogleUser(loggedInUser)) {
              analyticsTrack('ALI Signed Up', {
                provider: 'google.com',
              })
            } else {
              analyticsTrack('ALI Logged In', {
                provider: anovaJWTClaims['last_used_sign_in_provider'],
              })
            }

            const redirectURLWithOutgoingParams = addOutgoingParamsToRedirectURL(
              redirectURI,
              firebaseJWT,
              oAuthStateParameter,
              clientID,
              responseType,
              loggedInUser.uid
            )
            redirectToURL(redirectURLWithOutgoingParams)
          } else {
            if (this.state.isExistingCognitoUser) {
              isLoadingOrRedirecting = true

              await createAnovaIdentityWithVerifiedEmailFromCognito(
                this.state.email,
                this.state.password
              )

              analyticsTrack('ALI Logged In', {
                'migrated-from': 'cognito',
                provider: 'password',
              })

              // refresh token to pick up any custom claims added on create
              const firebaseJWT = await getFirebaseJWTForCurrentUser()
              const redirectURLWithOutgoingParams = addOutgoingParamsToRedirectURL(
                redirectURI,
                firebaseJWT,
                oAuthStateParameter,
                clientID,
                responseType,
                loggedInUser.uid
              )
              redirectToURL(redirectURLWithOutgoingParams)
            } else if (userCreatedAccountViaFacebook(loggedInUser)) {
              isLoadingOrRedirecting = true

              await createAnovaIdentityWithVerifiedEmailFromFacebook()

              analyticsTrack('ALI Logged In', {
                provider: 'facebook.com',
              })

              // refresh token to pick up any custom claims added on create
              const firebaseJWT = await getFirebaseJWTForCurrentUser()
              const redirectURLWithOutgoingParams = addOutgoingParamsToRedirectURL(
                redirectURI,
                firebaseJWT,
                oAuthStateParameter,
                clientID,
                responseType,
                loggedInUser.uid
              )
              redirectToURL(redirectURLWithOutgoingParams)
            } else {
              email = loggedInUser.email
              redirectToEmailVerification = true
            }
          }
        } else {
          try {
            // TODO
            // Delete this if-statement but keep the internal statement once we retire the iOS app.
            if (!nativeFacebookToken && !nativePendingCredentialProvider) {
              await firebase.auth().getRedirectResult()
            }
          } catch (error) {
            if (
              error.code === 'auth/account-exists-with-different-credential'
            ) {
              pendingCredential = error.credential

              const signInMethods = await firebase
                .auth()
                .fetchSignInMethodsForEmail(error.email)

              if (signInMethods[0] === 'password') {
                email = error.email
                shouldShowEnterPasswordToLinkFacebookToast = true
                storeShouldShowEnterPasswordToLinkFacebookToastFromLocalStorage(
                  true
                )
                redirectToEnterPassword = true
                isExistingFirebaseUser = true
                storeIsExistingFirebaseUserInLocalStorage(true)
                storePendingCredentialInSessionStorage(pendingCredential)
              } else if (signInMethods[0] === 'google.com') {
                storePendingCredentialInSessionStorage(pendingCredential)

                redirectToContinueWithGoogle = true
              }
            } else if (error.code === 'auth/user-cancelled') {
              const redirectURLWithOutgoingParams = addUserCancelledErrorToRedirectURL(
                redirectURI,
                oAuthStateParameter,
                clientID
              )
              redirectToURL(redirectURLWithOutgoingParams)
            }
          }
        }

        this.setState({
          email,
          redirectToEmailVerification,
          redirectToEnterPassword,
          redirectURI,
          showGDPROptions: true,
          isLoadingOrRedirecting,
          pendingCredential,
          isExistingCognitoUser,
          isExistingFirebaseUser,
          shouldShowEnterPasswordToLinkFacebookToast,
          redirectToContinueWithGoogle,
          oAuthStateParameter,
          clientID,
          nativeLogIn,
        })
      } catch (error) {
        console.log(error)
        analyticsTrack('ALI Errored', {
          message: error.message,
        })
      }
    })
  }

  componentWillUnmount() {
    removeNativeLogInFromLocalStorage()
  }

  render() {
    return (
      <ThemeProvider theme={defaultTheme}>
        <GlobalStyles>
          {this.state.isLoadingOrRedirecting ? <LoadingIndicator /> : null}
          <Router basename="/ali">
            <div>
              {this.state.shouldRedirect ? (
                <Redirect to={this.state.redirectURI} />
              ) : null}
              {this.state.redirectToEmailVerification ? (
                <Redirect to="/verify-email-pending" />
              ) : null}
              {this.state.redirectToEnterPassword ? (
                <Redirect to="/email-log-in-password" />
              ) : null}
              {this.state.redirectToContinueWithGoogle ? (
                <Redirect to="/continue-with-google" />
              ) : null}
              {this.state.redirectToContinueWithFacebook ? (
                <Redirect to="/continue-with-facebook" />
              ) : null}
              {this.state.redirectToContinueWithApple ? (
                <Redirect to="/continue-with-apple" />
              ) : null}
              <Switch>
                <Route
                  exact
                  path="/redirect"
                  render={() => {
                    window.location = this.state.redirectURI
                  }}
                />
                <Route
                  exact
                  path="/"
                  render={() => (
                    <LogInSelector
                      redirectURL={this.state.redirectURI}
                      clientID={this.state.clientID}
                      nativeLogIn={this.state.nativeLogIn}
                      marketingEmailOptInUser={
                        this.state.marketingEmailOptInUser
                      }
                      handleMarketingEmailOptInUser={
                        this.handleMarketingEmailOptInUser
                      }
                    />
                  )}
                />
                <Route
                  exact
                  path="/email-log-in"
                  render={() => (
                    <LogInEmailForm
                      checkEmailAndRedirectToEnterPassword={
                        this.checkEmailAndRedirectToEnterPassword
                      }
                      email={this.state.email}
                      handleEmailChangeAndClearEmailErrors={
                        this.handleEmailChangeAndClearEmailErrors
                      }
                      invalidEmail={this.state.invalidEmail}
                      redirectToEnterPassword={
                        this.state.redirectToEnterPassword
                      }
                    />
                  )}
                />
                <Route
                  exact
                  path="/email-log-in-password"
                  render={() => (
                    <LogInEmailPasswordForm
                      showGDPROptions={this.state.showGDPROptions}
                      wrongPassword={this.state.wrongPassword}
                      weakPassword={this.state.weakPassword}
                      emailAlreadyInUse={this.state.emailAlreadyInUse}
                      invalidEmail={this.state.invalidEmail}
                      userNotFound={this.state.userNotFound}
                      email={this.state.email}
                      password={this.state.password}
                      logIn={this.logIn}
                      signUp={this.signUp}
                      isExistingFirebaseUser={this.state.isExistingFirebaseUser}
                      isExistingCognitoUser={this.state.isExistingCognitoUser}
                      handleEmailChangeAndClearEmailErrors={
                        this.handleEmailChangeAndClearEmailErrors
                      }
                      handlePasswordChangeAndClearPasswordErrors={
                        this.handlePasswordChangeAndClearPasswordErrors
                      }
                      shouldShowEnterPasswordToLinkFacebookToast={
                        this.state.shouldShowEnterPasswordToLinkFacebookToast
                      }
                      dismissToastMessage={
                        this.dismissShowEnterPasswordToLinkFacebookToastMessage
                      }
                      logInEmailPasswordFormDidMount={
                        this.logInEmailPasswordFormDidMount
                      }
                      marketingEmailOptInUser={
                        this.state.marketingEmailOptInUser
                      }
                      handleMarketingEmailOptInUser={
                        this.handleMarketingEmailOptInUser
                      }
                    />
                  )}
                />
                <Route
                  exact
                  path="/password-reset"
                  render={() => (
                    <PasswordResetEmailForm
                      redirectURL={this.state.redirectURI}
                      setInvalidEmail={this.setInvalidEmail}
                      invalidEmail={this.state.invalidEmail}
                      userNotFound={this.state.userNotFound}
                      handleEmailChangeAndClearEmailErrors={
                        this.handleEmailChangeAndClearEmailErrors
                      }
                      email={this.state.email}
                    />
                  )}
                />
                <Route
                  exact
                  path="/password-reset-email-sent"
                  render={() => (
                    <PasswordResetEmailSent email={this.state.email} />
                  )}
                />
                <Route
                  exact
                  path="/make-new-password"
                  render={() => (
                    <MakeNewPasswordForm
                      email={this.state.email}
                      password={this.state.password}
                      redirectToPasswordChanged={
                        this.state.redirectToPasswordChanged
                      }
                      handlePasswordChangeAndClearPasswordErrors={
                        this.handlePasswordChangeAndClearPasswordErrors
                      }
                      weakPassword={this.state.weakPassword}
                      userNotFound={this.state.userNotFound}
                      expiredActionCode={this.state.expiredActionCode}
                      invalidActionCode={this.state.invalidActionCode}
                      checkFirebasePasswordResetCodeAndSetEmail={
                        this.checkFirebasePasswordResetCodeAndSetEmail
                      }
                      resetPassword={this.resetPassword}
                      setEmailFromQueryParams={this.setEmailFromQueryParams}
                    />
                  )}
                />
                <Route
                  exact
                  path="/password-changed"
                  component={PasswordChanged}
                />
                <Route
                  exact
                  path="/password-reset-failure"
                  component={PasswordResetFailure}
                />
                <Route
                  exact
                  path="/verify-email-pending"
                  render={() => (
                    <VerifyEmailPending
                      redirectURI={this.state.redirectURI}
                      oAuthStateParameter={this.state.oAuthStateParameter}
                      email={this.state.email}
                      clientID={this.state.clientID}
                    />
                  )}
                />
                <Route
                  exact
                  path="/verify-email-failure"
                  component={VerifyEmailFailure}
                />
                <Route
                  exact
                  path="/verify-email-success"
                  component={VerifyEmailSuccess}
                />
                <Route
                  exact
                  path="/continue-with-google"
                  component={ContinueWithGoogle}
                />
                <Route
                  exact
                  path="/continue-with-facebook"
                  component={ContinueWithFacebook}
                />
                <Route
                  exact
                  path="/continue-with-apple"
                  component={ContinueWithApple}
                />
              </Switch>
            </div>
          </Router>
        </GlobalStyles>
      </ThemeProvider>
    )
  }

  handleMarketingEmailOptInUser = () => {
    const marketingEmailOptInUser = !this.state.marketingEmailOptInUser

    localStorage.setItem('marketingEmailOptInUser', marketingEmailOptInUser)
    this.setState({ marketingEmailOptInUser })
  }

  checkEmailAndRedirectToEnterPassword = async () => {
    try {
      this.setState({ isLoadingOrRedirecting: true })

      const isExistingFirebaseUser = await emailExistsInFirebase(
        this.state.email
      )

      let isExistingCognitoUser = false

      let redirectToContinueWithGoogle = false
      let redirectToContinueWithFacebook = false
      let redirectToContinueWithApple = false
      let redirectToEnterPassword = true

      if (isExistingFirebaseUser) {
        redirectToContinueWithGoogle = await alreadyLoggedInWithGoogle(
          this.state.email
        )

        if (!redirectToContinueWithGoogle) {
          redirectToContinueWithFacebook = await alreadyLoggedInWithFacebook(
            this.state.email
          )
        }

        if (!redirectToContinueWithGoogle && !redirectToContinueWithFacebook) {
          redirectToContinueWithApple = await alreadyLoggedInWithApple(
            this.state.email
          )
        }

        if (
          redirectToContinueWithFacebook ||
          redirectToContinueWithGoogle ||
          redirectToContinueWithApple
        ) {
          redirectToEnterPassword = false
        }
      } else {
        isExistingCognitoUser = await emailExistsInCognito(this.state.email)
      }

      storeIsExistingCognitoUserInLocalStorage(isExistingCognitoUser)
      storeIsExistingFirebaseUserInLocalStorage(isExistingFirebaseUser)
      storeEmailInLocalStorage(this.state.email)

      this.setState({
        isExistingFirebaseUser,
        isExistingCognitoUser,
        redirectToEnterPassword,
        redirectToContinueWithGoogle,
        redirectToContinueWithFacebook,
        redirectToContinueWithApple,
        isLoadingOrRedirecting: false,
      })
    } catch (error) {
      let invalidEmail = false

      if (error.code === 'auth/invalid-email') {
        invalidEmail = true
      }

      this.setState({
        invalidEmail,
        isLoadingOrRedirecting: false,
      })
    }
  }

  handleEmailChangeAndClearEmailErrors = email => {
    this.setState({
      email,
      emailAlreadyInUse: false,
      invalidEmail: false,
      userNotFound: false,
    })
  }

  handlePasswordChangeAndClearPasswordErrors = password => {
    this.setState({
      password,
      wrongPassword: false,
      weakPassword: false,
    })
  }

  logIn = async () => {
    if (
      this.state.isExistingCognitoUser &&
      !this.state.isExistingFirebaseUser
    ) {
      try {
        this.setState({ isLoadingOrRedirecting: true })

        await logInCognitoUser(this.state.email, this.state.password)
        await createFirebaseAccount(this.state.email, this.state.password)
      } catch (error) {
        console.log(error)

        this.setState({
          wrongPassword: true,
          isLoadingOrRedirecting: false,
        })
      }
    } else if (this.state.isExistingFirebaseUser) {
      try {
        this.setState({ isLoadingOrRedirecting: true })

        await logInFirebaseUser(this.state.email, this.state.password)
      } catch (error) {
        console.log(error)

        let wrongPassword = false
        let invalidEmail = false
        let userNotFound = false

        if (error.code === 'auth/wrong-password') {
          wrongPassword = true
        } else if (error.code === 'auth/invalid-email') {
          invalidEmail = true
        } else if (error.code === 'auth/user-not-found') {
          userNotFound = true
        }

        this.setState({
          wrongPassword,
          invalidEmail,
          userNotFound,
          isLoadingOrRedirecting: false,
        })
      }
    } // TODO should never happen, should panic here
  }

  signUp = async () => {
    try {
      this.setState({ isLoadingOrRedirecting: true })

      await firebase
        .auth()
        .createUserWithEmailAndPassword(this.state.email, this.state.password)
      await sendVerificationEmail(this.state.redirectURI)

      storeEmailInLocalStorage(this.state.email)

      this.setState({
        redirectToEmailVerification: true,
        isLoadingOrRedirecting: false,
      })
    } catch (error) {
      console.log(error)

      let weakPassword = false
      let emailAlreadyInUse = false
      let invalidEmail = false

      if (error.code === 'auth/weak-password') {
        weakPassword = true
      } else if (error.code === 'auth/email-already-in-use') {
        emailAlreadyInUse = true
      } else if (error.code === 'auth/invalid-email') {
        invalidEmail = true
      }

      this.setState({
        weakPassword,
        emailAlreadyInUse,
        invalidEmail,
        isLoadingOrRedirecting: false,
      })
    }
  }

  setInvalidEmail = invalidEmail => {
    this.setState({ invalidEmail })
  }

  resetPassword = async () => {
    try {
      const actionCode = getActionCodeFromQueryParams()
      await resetFirebasePassword(actionCode, this.state.password)

      analyticsTrack('ALI Password Reset')

      this.setState({ redirectToPasswordChanged: true })
    } catch (error) {
      if (error.code === 'auth/expired-action-code') {
        this.setState({ expiredActionCode: true })
      } else if (error.code === 'auth/invalid-action-code') {
        this.setState({ invalidActionCode: true })
      } else if (error.code === 'auth/user-not-found') {
        this.setState({ userNotFound: true })
      } else if (error.code === 'auth/weak-password') {
        this.setState({ weakPassword: true })
      }
    }
  }

  checkFirebasePasswordResetCodeAndSetEmail = async () => {
    try {
      const passwordResetCode = getActionCodeFromQueryParams()
      const email = await checkFirebasePasswordResetCodeAndGetEmail(
        passwordResetCode
      )
      this.setState({ email })
    } catch (error) {
      if (error.code === 'auth/expired-action-code') {
        this.setState({ expiredActionCode: true })
      } else if (error.code === 'auth/invalid-action-code') {
        this.setState({ invalidActionCode: true })
      } else if (error.code === 'auth/user-not-found') {
        this.setState({ userNotFound: true })
      }
    }
  }

  dismissShowEnterPasswordToLinkFacebookToastMessage = () => {
    removeShouldShowEnterPasswordToLinkFacebookToastFromLocalStorage()

    this.setState({ shouldShowEnterPasswordToLinkFacebookToast: false })
  }

  logInEmailPasswordFormDidMount = () => {
    this.setState({ redirectToEnterPassword: false })
  }
}

export default App
